import { useObservable } from '@logz-pkg/observable';
import { urlParamsStateService } from '../url-params.state.service';

export const useUrlParamsStateService = (stateName: string) => {
  const params = useObservable(urlParamsStateService.urlParams);

  return params?.[stateName];
};
